/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';
import {
  useState, useEffect, cloneElement,
  useRef,
  useCallback,
} from 'react';
import styles from './TableOfContentsMobileMenu.module.scss';
import UpArrowIcon from '../svgs/up-arrow';
import BurgerMenuIcon from '../svgs/burger-menu';
import CloseIcon from '../svgs/close';

export default function TableOfContentsMobileMenu({
  isMenuOpen = null, setIsMenuOpen = () => {}, activeSection = null, children = null,
  top = false, left = false, defaultTitle = '',
}) {
  const [atTop, setAtTop] = useState(true);
  const [menuTitle, setMenuTitle] = useState(defaultTitle);
  const [isOpen, setIsOpen] = useState(false);
  const [closing, setClosing] = useState(false);

  const menuRef = useRef();
  const menuButtonsRef = useRef();

  const containerClassName = [
    styles['toc-mobile-menu__mobile-navigation'],
    top ? styles['--top'] : '',
    left ? styles['--left'] : '',
  ].join(' ').trim();

  const menuClassName = [
    styles['toc-mobile-menu__mobile-navigation-menu'],
    closing ? styles['--closing'] : '',
  ].join(' ').trim();

  useEffect(() => {
    if ((isMenuOpen !== null && isMenuOpen !== undefined) && (isMenuOpen !== isOpen)) {
      setIsOpen(isMenuOpen);
    }
  }, [isMenuOpen]);

  const scrollToTop = () => {
    setMenuTitle(defaultTitle);
    window.scrollTo(0, 'smooth');
  };

  const checkIfAtTop = () => {
    if (window.scrollY > 100) {
      setAtTop(false);
    } else {
      setAtTop(true);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', checkIfAtTop);
    return () => {
      document.removeEventListener('scroll', checkIfAtTop);
    };
  }, []);

  const handleMenuOpen = () => {
    document.body.style.overflow = 'hidden';
    setIsOpen(true);
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    document.body.style.overflow = 'auto';
    setClosing(true);
  };

  const originalOnSetActive = children.props.onSetActive;

  const child = cloneElement(children, {
    onSetActive: (anchor) => {
      if (originalOnSetActive) {
        originalOnSetActive(anchor);
      }
      setMenuTitle(anchor);
    },
    onItemClick: handleMenuClose,
  });
  const closeIfOutsideClick = useCallback((e) => {
    if ((!menuRef?.current?.contains(e.target)
      && !menuButtonsRef?.current?.contains(e.target)
      && isOpen)) {
      handleMenuClose();
    }
  }, [isOpen, menuRef]);

  useEffect(() => {
    window.addEventListener('click', closeIfOutsideClick);
    return () => {
      window.removeEventListener('click', closeIfOutsideClick);
    };
  }, [isOpen]);

  return (
    <>
      <div className={containerClassName}>
        {!atTop && (
          <div
            className={styles['toc-mobile-menu__mobile-navigation-button']}
            onClick={scrollToTop}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                scrollToTop();
              }
            }}
          >
            <div className={[styles['toc-mobile-menu__button-icon'], styles['--white']].join(' ').trim()}>
              <UpArrowIcon title="return to top of page icon" />
            </div>
          </div>
        )}
        <div
          ref={menuButtonsRef}
          className={styles['toc-mobile-menu__mobile-navigation-button']}
          onClick={handleMenuOpen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              scrollToTop();
            }
          }}
        >
          <div className={[styles['toc-mobile-menu__button-icon'], styles['--white']].join(' ').trim()}>
            <BurgerMenuIcon title="table of contents menu icon" />
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          className={menuClassName}
          ref={menuRef}
          onAnimationEnd={(e) => {
            if (e.animationName === styles.closeMenu) {
              setClosing(false);
              setIsOpen(false);
              setIsMenuOpen(false);
            }
          }}
        >
          <div
            className={
              styles['toc-mobile-menu__mobile-navigation-menu-active-section']
            }
          >
            <div className={styles['toc-mobile-menu__active-section-title']}>
              {activeSection || menuTitle}
            </div>
            <div
              onClick={handleMenuClose}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  scrollToTop();
                }
              }}
            >
              <div className={styles['toc-mobile-menu__button-icon']}>
                <CloseIcon title="close table of contents menu icon" />
              </div>
            </div>
          </div>
          {child}
        </div>
      )}
    </>
  );
}

TableOfContentsMobileMenu.propTypes = {
  isMenuOpen: PropTypes.bool,
  setIsMenuOpen: PropTypes.func,
  activeSection: PropTypes.string,
  children: PropTypes.node,
  top: PropTypes.bool,
  left: PropTypes.bool,
  defaultTitle: PropTypes.string,
};
